import { Component, OnInit } from '@angular/core';
import { CommunicationService } from 'src/app/services/Communication/communication.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html',
  styleUrls: ['./communication.component.css']
})
export class CommunicationComponent implements OnInit {

  StaffList = [];
  StudentList = [];
  Submitted = false;
  PersonList = [];
  CommunicationTypeList = [];
  CommunicationList = [];
  ClassList = [];
  SectionList = [];
  Student = [];
  DesignationList = [];
  DepartmentList = [];
  EmployeeCategoryList = [];
  EmployeeTypeList = [];
  Count1 = 0;
  Count2 = 0;
  Count3 = 0;

  constructor(private communicationservice: CommunicationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  SearchModel = {
    ClassID: 0,
    SectionID: 0,
    StudentID: 0,
    EmployeeCategoryID: 0,
    EmployeeTypeID: 0,
    PrimaryDepartmentID: 0,
    DesignationID: 0,
    CurrentIndex: 0,
    PageSize: 0,
    CommunicationTypeID: 0,
    Name: '',
    PersonTypeID: 0,
    FromDate: moment(new Date()).format('DD-MMM-YYYY'),
    ToDate: moment(new Date()).format('DD-MMM-YYYY'),
  }

  ClearSearch() {
    this.StaffList = [];
    this.StudentList = [];
    this.SearchModel.ClassID = 0;
    this.SearchModel.SectionID = 0;
    this.SearchModel.StudentID = 0;
    this.SearchModel.EmployeeCategoryID = 0;
    this.SearchModel.EmployeeTypeID = 0;
    this.SearchModel.PrimaryDepartmentID = 0;
    this.SearchModel.DesignationID = 0;
  };

  ClearFilter() {

    this.SearchModel.CommunicationTypeID = 0;
    this.SearchModel.Name = '';
    this.SearchModel.FromDate = moment(new Date()).format('DD-MMM-YYYY');
    this.SearchModel.ToDate = moment(new Date()).format('DD-MMM-YYYY');
    this.GetAllCommunication();

  };
  ClearSave() {
    this.SaveUpdateModel.CommunicationTypeID = 0;
    this.SaveUpdateModel.Message = '';
  };

  SaveUpdateModel = {
    PersonTypeID: 0,
    SendTypeID: 1,
    CommunicationTypeID: 0,
    Message: '',
    MessageType: "TEXT",
    CommunicationType: '',
    Mobile: '',
  }



  ChangePersonType() {
    this.SearchModel.PersonTypeID = this.SaveUpdateModel.PersonTypeID;
    this.ClearFilter();
    this.GetCommunicationType();
    this.GetAllCommunication();
    this.StaffList = [];
    this.StudentList = [];
    this.SelectModel.IsSelect = false;
    for (var i = 0; i < this.StudentList.length; i++) {

      this.StudentList[i].Active = false;

    }
    for (var i = 0; i < this.StaffList.length; i++) {
      this.StaffList[i].Active = false;

    }

  }

  ValidityState() {
    return this.SaveUpdateModel.CommunicationTypeID == 0;
  }
  AlbumPhoto= [];
  getFileDetails(e) {
    this.AlbumPhoto = [];
    for (var i = 0; i < e.target.files.length; i++) {  
      this.AlbumPhoto.push(e.target.files[i]) 
    }
  }
  SaveCommunication() {
    this.Submitted
      = true;
    this.PersonList = [];
    for (i = 0; i < this.CommunicationTypeList.length; i++) {
      if (this.CommunicationTypeList[i].ItemId == this.SaveUpdateModel.CommunicationTypeID) {
        this.SaveUpdateModel.CommunicationType = this.CommunicationTypeList[i].ItemName;
        break;
      }
    }
    var Mobile = '';
    if (this.SaveUpdateModel.PersonTypeID == 1 && !this.ValidityState()) {

      for (var i = 0; i < this.StudentList.length; i++) {
        if (this.StudentList[i].IsSelect == true) {
          var item = {
            PersonID: this.StudentList[i].StudentID,
            AppRegID: this.StudentList[i].AppRegID
          }
          this.PersonList.push(item);
        }

      }
      for (var i = 0; i < this.StudentList.length; i++) {

        if (this.StudentList[i].Mobile != null && this.StudentList[i].IsSelect == true && Mobile == '') {
          Mobile = this.StudentList[i].Mobile;
        }
        else if (this.StudentList[i].Mobile != null && this.StudentList[i].IsSelect == true) {
          Mobile = Mobile + "," + this.StudentList[i].Mobile;
        }
        if (this.StudentList[i].FatherContactCell != null && this.StudentList[i].IsSelect == true && this.StudentList[i].IsFatherSelect == true) {
          Mobile = Mobile + "," + this.StudentList[i].FatherContactCell;
        }

        if (this.StudentList[i].MotherContactCell != null && this.StudentList[i].IsSelect == true && this.StudentList[i].IsMotherSelect == true) {

          Mobile = Mobile + "," + this.StudentList[i].MotherContactCell;
        }

      }
      this.SaveUpdateModel.Mobile = Mobile;

      if (this.PersonList.length == 0) {
        return;
      }
      if (confirm("Are you sure to send  the communication")) {
        this.spinnerService.show();
        this.communicationservice.SaveCommunication(JSON.stringify(this.PersonList), JSON.stringify(this.SaveUpdateModel),this.AlbumPhoto).subscribe((data: any) => {
          this.spinnerService.hide();
          this.Submitted
            = false;
          if (data.webResponse.Status) {
            this.ClearSave();
            this.GetAllCommunication();
          }
          this.globalHelper.CheckActionStatus(data);
        });

      }
      return false;


    }
    else if (this.SaveUpdateModel.PersonTypeID == 2 && !this.ValidityState()) {

      for (var i = 0; i < this.StaffList.length; i++) {
        if (this.StaffList[i].IsSelect == true) {
          var item = {
            PersonID: this.StaffList[i].StaffID,
            AppRegID: this.StaffList[i].AppRegID
          }
          this.PersonList.push(item);
        }

      }
      for (var i = 0; i < this.StaffList.length; i++) {

        if (this.StaffList[i].Mobile != null && this.StaffList[i].IsSelect == true && Mobile == '') {
          Mobile = this.StaffList[i].Mobile;
        }
        else if (this.StaffList[i].Mobile != null && this.StaffList[i].IsSelect == true) {
          Mobile = Mobile + "," + this.StaffList[i].Mobile;
        }

      }
      this.SaveUpdateModel.Mobile = Mobile;
      if (this.PersonList.length == 0) {
        return;
      }
      if (confirm("Are you sure to send  the communication")) {
        this.spinnerService.show();
        this.communicationservice.SaveCommunication(JSON.stringify(this.PersonList), JSON.stringify(this.SaveUpdateModel),this.AlbumPhoto).subscribe((data: any) => {
          this.spinnerService.hide();
          this.Submitted = false;
          if (data.webResponse.Status) {
            this.ClearSave();
            this.GetAllCommunication();
          }
          this.globalHelper.CheckActionStatus(data);
        });

      }
      return false;
    }
  }

  GetAllCommunication() {
    this.spinnerService.show();
    this.communicationservice.GetAllCommunication(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.CommunicationList = data.CommunicationList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });
  };

  // Init and Look Up



  GetStudentDetails() {
    this.spinnerService.show();
    this.communicationservice.GetStudentDetails(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.StudentList = data.ListStuAdmission;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });
  };


  GetStaffDetails() {
    this.spinnerService.show();
    this.communicationservice.GetStaffDetails(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.StaffList = data.StaffList;
      this.spinnerService.hide();

    });
  };



  ngOnInit() {
    this.GetEmployeeType();
    this.GetDesignation();
    this.GetDepartment();
    this.GetEmployeeCategory();
    this.GetClass();
  }

  GetCommunicationType() {
    this.SaveUpdateModel.CommunicationTypeID = 0;
    this.CommunicationTypeList = [];
    var itemBo = {
      'ItemId': this.SaveUpdateModel.PersonTypeID,
    };
    this.lookupservice.GetLookupsList('CommunicationType', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.CommunicationTypeList = data.LookupItems;

      var itemadd = {
        'ItemId': -1,
        'ItemName': 'OTHERS'
      }
      this.CommunicationTypeList.push(itemadd);
    });
  };

  GetClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  };

  GetSection() {
    this.spinnerService.show();
    this.SearchModel.SectionID = 0;
    this.SearchModel.StudentID = 0;
    this.StudentList = [];
    var itemBo = {
      'ItemId': this.SearchModel.ClassID,

    };
    this.lookupservice.GetLookupsList('SectionName', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
      this.spinnerService.hide();
    });

  };

  GetStudent() {
    this.spinnerService.show();
    this.StudentList = []
    var itemBo = {
      'ItemId': this.SearchModel.ClassID,
      'ItemId2': this.SearchModel.SectionID
    };
    this.lookupservice.GetLookupsList('Student', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.Student = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetDesignation() {
    var itembo = {
      'ItemID': 1,
    }
    this.lookupservice.GetLookupsList('Designation', JSON.stringify(itembo)).subscribe((data: any) => {
      this.DesignationList = data.LookupItems;
    });
  };

  GetDepartment() {
    this.lookupservice.GetLookupsList('Department', '').subscribe((data: any) => {
      this.DepartmentList = data.LookupItems;
    });
  };

  GetEmployeeCategory() {
    this.lookupservice.GetLookupsList('PersonnelType', '').subscribe((data: any) => {
      this.EmployeeCategoryList = data.LookupItems;

    });
  };

  GetEmployeeType() {

    this.lookupservice.GetLookupsList('EmployeeType', '').subscribe((data: any) => {
      this.EmployeeTypeList = data.LookupItems;
    });
  };


  // Select All

  SelectModel = {
    IsSelect: false,
    Active: false,
    FatherActive: false,
    MotherActive: false,

  }

  SelectAll() {

    if (this.SelectModel.Active && this.SaveUpdateModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {

        this.StudentList[i].IsSelect = true;

      }
    }
    if (this.SelectModel.Active == false && this.SaveUpdateModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].IsSelect = false;

      }
    }
    if (this.SelectModel.FatherActive && this.SaveUpdateModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {

        this.StudentList[i].IsFatherSelect = true;

      }
    }
    if (this.SelectModel.FatherActive == false && this.SaveUpdateModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].IsFatherSelect = false;

      }
    }

    if (this.SelectModel.MotherActive && this.SaveUpdateModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {

        this.StudentList[i].IsMotherSelect = true;

      }
    }
    if (this.SelectModel.MotherActive == false && this.SaveUpdateModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].IsMotherSelect = false;

      }
    }
    if (this.SelectModel.Active && this.SaveUpdateModel.PersonTypeID == 2) {
      for (var i = 0; i < this.StaffList.length; i++) {

        this.StaffList[i].IsSelect = true;

      }
    }
    if (this.SelectModel.Active == false && this.SaveUpdateModel.PersonTypeID == 2) {
      for (var i = 0; i < this.StaffList.length; i++) {
        this.StaffList[i].IsSelect = false;

      }
    }

  }

  ChangeSelect(item) {
    this.Count1 = 0;
    this.Count2 = 0;
    this.Count3 = 0;
    if (this.SaveUpdateModel.PersonTypeID == 1) {
      for (var i = 0; i < this.StudentList.length; i++) {
        if (this.StudentList[i].IsSelect) {
          this.Count1 = this.Count1 + 1;
        }
        if (this.StudentList[i].IsFatherSelect) {
          this.Count2 = this.Count2 + 1;
        }
        if (this.StudentList[i].IsMotherSelect) {
          this.Count3 = this.Count3 + 1;
        }
      }
      if (this.Count1 == this.StudentList.length) {
        this.SelectModel.Active = true;

      }
      else {
        this.SelectModel.Active = false;
      }

      if (this.Count2 == this.StudentList.length) {
        this.SelectModel.FatherActive = true;

      }
      else {
        this.SelectModel.FatherActive = false;
      }
      if (this.Count3 == this.StudentList.length) {
        this.SelectModel.MotherActive = true;

      }
      else {
        this.SelectModel.MotherActive = false;
      }

    }
    if (this.SaveUpdateModel.PersonTypeID == 2) {
      for (var i = 0; i < this.StaffList.length; i++) {
        if (this.StaffList[i].IsSelect) {
          this.Count1 = this.Count1 + 1;

        }
      }
      if (this.Count1 == this.StaffList.length) {
        this.SelectModel.Active = true;

      }
      else {
        this.SelectModel.Active = false;
      }

    }


  }



  // Download

  CommunicationListDownload() {
    if (this.CommunicationList != null) {
      this.JSONToCsvConverterList(this.CommunicationList, 'Communication_List', true);
    }

  };

  JSONToCsvConverterList(JSONData, ReportTitle, ShowLabel) {
    var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
      var row = "";
      row += 'Sr. No.' + ',';
      row += 'Date' + ',';
      if (this.SaveUpdateModel.PersonTypeID == 1) {
        row += 'GR No.' + ',';
      }
      else if (this.SaveUpdateModel.PersonTypeID == 2) {
        row += 'Employee ID' + ',';
      }
      row += 'Name' + ',';
      if (this.SaveUpdateModel.PersonTypeID == 1) {
        row += 'Class' + ',';
      }
      else if (this.SaveUpdateModel.PersonTypeID == 2) {
        row += 'Department' + ',';
      }
      if (this.SaveUpdateModel.PersonTypeID == 1) {
        row += 'Section' + ',';
      }
      else if (this.SaveUpdateModel.PersonTypeID == 2) {
        row += 'Designation' + ',';
      }
      row += 'Communication Type' + ',';
      row += 'Details of Communication' + ',';
      row = row.slice(0, -1);
      CSV += row + '\r\n';
    }
    for (var i = 0; i < arrayData.length; i++) {
      var sno = i + 1;
      var row = "";
      row += '"' + sno + '",';
      row += '"' + moment(arrayData[i].CreatedOn).format('DD-MMM-YYYY') + '",';
      if (this.SaveUpdateModel.PersonTypeID == 1) {
        row += '"' + arrayData[i].GRNo + '",';
      }
      else if (this.SaveUpdateModel.PersonTypeID == 2) {
        row += '"' + arrayData[i].StaffIdentity + '",';
      }
      row += '"' + arrayData[i].Name + '",';
      if (this.SaveUpdateModel.PersonTypeID == 1) {
        row += '"' + arrayData[i].ClassName + '",';
      }
      else if (this.SaveUpdateModel.PersonTypeID == 2 && arrayData[i].DepartmentName != null) {
        row += '"' + arrayData[i].DepartmentName + '",';
      }
      else {
        row += '"' + '' + '",';
      }
      if (this.SaveUpdateModel.PersonTypeID == 1) {
        row += '"' + arrayData[i].SectionName + '",';
      }
      else if (this.SaveUpdateModel.PersonTypeID == 2 && arrayData[i].DesignationName != null) {
        row += '"' + arrayData[i].DesignationName + '",';
      }
      else {
        row += '"' + '' + '",';
      }
      if (arrayData[i].CommunicationTypeID == -1) {
        row += '"' + 'OTHERS' + '",';
      }
      else {
        row += '"' + arrayData[i].CommunicationType + '",';
      }
      row += '"' + arrayData[i].Message + '",';
      row.slice(0, row.length - 1);
      CSV += row + '\r\n';
    }
    if (CSV == '') {
      alert('Invalid Data');
      return;
    }
    var FileName = ReportTitle + '_' + +  moment(new Date()).format('DD-MMM-YYYY');
    var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', FileName + '.csv');
    tempLink.click();
  }



}
